import httpClient from 'utils/httpClient.js';

const path = '/commission';
const MASTER_CACHE_TTL = 60 * 1000;
const masterCache = new Map();

const getCachedMasterData = (key, loader) => {
  const now = Date.now();
  const cached = masterCache.get(key);
  if (cached?.data && cached.expiresAt > now) return Promise.resolve(cached.data);
  if (cached?.promise) return cached.promise;

  const promise = loader()
    .then((data) => {
      masterCache.set(key, { data, expiresAt: Date.now() + MASTER_CACHE_TTL });
      return data;
    })
    .catch((error) => {
      masterCache.delete(key);
      throw error;
    });
  masterCache.set(key, { promise, expiresAt: now + MASTER_CACHE_TTL });
  return promise;
};

export const getListCommission = (params) => {
  return httpClient.get(`${path}`, { params });
};

export const createCommission = (_data) => {
  return httpClient.post(`${path}`, _data);
};

export const updateCommission = (id, _data) => {
  return httpClient.put(`${path}/${id}`, _data);
};

export const stopCommission = (id, _data) => {
  return httpClient.put(`${path}/${id}/stop`, _data);
};

export const deleteCommission = (id) => {
  return httpClient.delete(`${path}/${id}`);
};

export const delCommission = (ids = []) => {
  return httpClient.post(`${path}/delete`, { ids });
};

export const getCommissionCompanyOptions = () => {
  return httpClient.get(`${path}/company/get-options`);
};

export const getCommissionDetail = (id) => {
  return httpClient.get(`${path}/${id}`);
};

export const exportCommissionExcel = (id) =>
  httpClient.get(`${path}/${id}/export-excel`, { responseType: 'blob' });

export const getOptionsOrderType = () => {
  return getCachedMasterData('order-types', () => httpClient.get(`/order-type?is_active=1`));
};

export const resolveOrderCommissionPolicy = (_data) => {
  return httpClient.post(`${path}/resolve-order-policy`, _data);
};

export const getCommissionPolicyCategories = (params) => {
  const includeInactive = Number(params?.include_inactive || 0);
  const allBases = Number(params?.all_bases || 0);
  if (params?.refresh) return httpClient.get(`${path}/policy-categories`, { params });
  return getCachedMasterData(`policy-categories:${includeInactive}:${allBases}`, () =>
    httpClient.get(`${path}/policy-categories`, { params }),
  );
};

export const saveCommissionPolicyCategory = async (_data) => {
  const result = await httpClient.post(`${path}/policy-categories`, _data);
  Array.from(masterCache.keys())
    .filter((key) => key.startsWith('policy-categories:'))
    .forEach((key) => masterCache.delete(key));
  return result;
};

export const getDepartmentPosition = (params) => {
  return httpClient.get(`${path}/department-position`, { params });
};

export const getDepartmentPositionV2 = (params) => {
  return httpClient.get(`${path}/department-position-v2`, { params });
};

export const getUserDepartmentOptions = (params) => {
  return httpClient.get(`${path}/user-department-options`, { params });
};

export const getCommissionTargetUserOptions = (params) => {
  return httpClient.get(`${path}/target-user-options`, { params });
};

export const getCommissionPolicyProductOptions = (params) => {
  return httpClient.get(`${path}/policy-product-options`, { params });
};

export const getCommissionPolicyImeiOptions = (params) =>
  httpClient.get(`${path}/policy-imei-options`, { params });

// Duyệt hoa hồng
export const reviewCommissions = (params = {}) => {
  return httpClient.put(`${path}/review`, { ...params });
};
